import { pipe, equals } from 'ramda'

/**
 * Evaluates if the supplied argument evaluates to "true".
 */
const isTruthy = pipe(Boolean, equals(true))

export default isTruthy
